import { message, Modal } from "antd";
import { boardServices } from "../api";
import axios from "axios";

const hardcodeToken = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJiZWEwODRmMS1iOWI0LTQ2ZGEtYjZiZi1kNDg1YjE2YWJjZGQiLCJuYW1lIjoiQXJlZWogWmFoaWQgQWxpIiwiaW1hZ2UiOiJodHRwczovL3dvcmt3LmNvbS9SZXNvdXJjZXNcXDBhYjVmOWMwLWY5NDgtNGM0MC04ZGFkLWM1OGJhOTlmYjc2NVxcSW1hZ2VzXFxiZGM2YmM1NC0wNjAwLTQxOGYtYTM0OS1mMDIyMWRhYjU2MGYuanBlZyIsImVtYWlsIjoiYXJlZWpAbWlsZXRhcC5jb20iLCJidXNpbmVzc0lkIjoiMGFiNWY5YzAtZjk0OC00YzQwLThkYWQtYzU4YmE5OWZiNzY1IiwidmVyIjoiODIzODlFQkMtMDA1OS00NEUzLUI1QjUtMUM0REU0NzcwQ0E1IiwiaWgiOiJ4NHhyNDF0Q0Z4dm81R09uM05iQ3ZOWFFmOFNzL1hWL01KZ0RJbFNDblhJPSIsImlzIjoiaFN0aHRCOGhqcVBYcGVFa2hOMVF5Zz09IiwicGgiOiJuSEc3RTZvZWtscTB5d3BTRWZhN29WaStFdkQ2VVlYbG1jN1QwbGJjaFhrPSIsInBzIjoiZkJENmN4ZjZNWGl4VUlzYUZKcEM1Zz09IiwiaXNBZ2VudCI6IkZhbHNlIiwianRpIjoiNmExOTM2ZTUtNDc1Mi00YTU2LWJlZmEtNzcyODNkMjQ2N2MxIiwibmJmIjoxNzcyMjU4NzY4LCJleHAiOjE3NzI0MzE1Njh9.npIGJ_JLiYRFoWd02tHZcyf3rn3PGAY6W0PilCEBJeHaY4Jm2mRrltLBpAQMkiX7hmDlU5XKXEX6AC8r-N9pWxNBCubIOUAg6HHJaUk-4UfugLFK8G0uYauhMp6bGYWTUVW7G0EPMiR9F16pM8s_5rffsUsvEn0XTBYrXbgbl1HZids5bn6hdBO-CdasIgS_STh2o5BHtP1RjRAENu1tLFBNPUdE4wl3LAen0rAPGDXs8JyLIoB33bWAqG3g9RVWSxJIRaLuOy0MOBgGftSFAnpezvNvCPQlLTxP5rHuV4Sym1M7Kb998w3uphl_tuYxxlutwH21Vb9zCpND0uPl6w";

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue("token")
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || hardcodeToken;
  return finalToken;
}

export const getUserInfoFromToken = () => {
  try {
    const token = getWorkWiseAuthToken();

    if (!token) return null;

    let decoded = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());

    return decoded || null;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const units = ["Bytes", "KB", "MB", "GB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  if (unitIndex === 0) {
    return `${size} ${units[unitIndex]}`;
  } else if (unitIndex === 1 && size < 50) {
    return `${parseFloat(size.toFixed(0))} ${units[unitIndex]}`;
  } else {
    return `${parseFloat(size.toFixed(2))} ${units[unitIndex]}`;
  }
};


export const getWatermarkData = async () => {
  const now = new Date();
  const currentDateTime = now.toLocaleString();

  // Get IP address
  let ip = 'N/A';
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    ip = data.ip;
  } catch (error) {
    console.error("Error fetching IP:", error);
    message.error("Could not fetch IP address");
  }

  // Get location
  let location = { lat: 'N/A', lng: 'N/A' };
  try {
    location = await new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        message.error("Geolocation not supported");
        return resolve(location);
      }

      navigator.geolocation.getCurrentPosition(
        (position) => resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }),
        (error) => {
          handleGeolocationError(error);
          resolve(location); // Return default on error
        }
      );
    });
  } catch (error) {
    console.error("Location error:", error);
  }

  return {
    currentDateTime,
    ip,
    location
  };
};

const handleGeolocationError = (error) => {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      message.error("Location access denied. Please enable permissions.");
      break;
    case error.POSITION_UNAVAILABLE:
      message.error("Location information unavailable.");
      break;
    case error.TIMEOUT:
      message.error("Location request timed out.");
      break;
    default:
      message.error("Unknown location error occurred.");
  }
};
export const getMaxRightOfElement = (canvas) => {
  let maxRight = 0;

  canvas.getObjects().forEach((obj) => {
    // Calculate right edge considering scale
    const rightEdge = obj.left + (obj.width || 0) * (obj.scaleX || 1);

    if (rightEdge > maxRight) {
      maxRight = rightEdge;
    }
  });

  return maxRight;
};
export const centerObjectInViewport = (canvas, obj) => {
  const zoom = canvas.getZoom();
  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();

  const centerX = obj.left + (obj.width * (obj.scaleX || 1)) / 2;
  const centerY = obj.top + (obj.height * (obj.scaleY || 1)) / 2;

  const vpt = canvas.viewportTransform.slice();
  vpt[4] = canvasWidth / 2 - centerX * zoom;
  vpt[5] = canvasHeight / 2 - centerY * zoom;

  canvas.setViewportTransform(vpt);
  canvas.renderAll();
};

export const centerAllObjectsInViewport = (canvas) => {
  const objects = canvas.getObjects();
  if (objects.length === 0) return;

  const zoom = canvas.getZoom();
  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();

  // Calculate the bounding box for all objects
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

  objects.forEach(obj => {
    const scaleX = obj.scaleX || 1;
    const scaleY = obj.scaleY || 1;
    const width = obj.width * scaleX;
    const height = obj.height * scaleY;

    const left = obj.left;
    const top = obj.top;

    minX = Math.min(minX, left);
    minY = Math.min(minY, top);
    maxX = Math.max(maxX, left + width);
    maxY = Math.max(maxY, top + height);
  });

  const groupWidth = maxX - minX;
  const groupHeight = maxY - minY;

  const centerX = minX + groupWidth / 2;
  const centerY = minY + groupHeight / 2;

  const vpt = canvas.viewportTransform.slice();
  vpt[4] = canvasWidth / 2 - centerX * zoom;
  vpt[5] = canvasHeight / 2 - centerY * zoom;

  canvas.setViewportTransform(vpt);
  canvas.renderAll();
};

export const saveToLocalStorage = (docId, data) => {
  try {
    const localData = {
      data: data,
      lastUpdateTime: new Date().toISOString()
    };
    // Retrieve existing data from localStorage or initialize with an empty object
    const existingData = JSON.parse(localStorage.getItem('offlineIdeationData')) || {};
    // Replace or add the sheet data for the given docId
    existingData[docId] = localData;
    // Save updated data back to localStorage
    localStorage.setItem('offlineIdeationData', JSON.stringify(existingData));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

export const removeOfflineData = (id) => {
  const offlineData = JSON.parse(localStorage.getItem('offlineIdeationData') || '{}');
  delete offlineData[id];
  localStorage.setItem('offlineIdeationData', JSON.stringify(offlineData));
};

export const isOffline = () => {
  return !navigator.onLine;
};

export const processTemplateData = (serverResponse) => {
  let templateData = serverResponse?.data?.data || null;
  if (templateData?.milepadData) {
    const rawData = JSON.parse(templateData.milepadData);
    delete templateData.milepadData;
    templateData.mileboardData = rawData;
  }
  return templateData;
};

export const removeTemplateIdFromURL = (history) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete('templateId');
  const newSearch = searchParams.toString();
  history.replace({
    pathname: window.location.pathname,
    search: newSearch ? `?${newSearch}` : ''
  });
};
